import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

// available OS : AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS, iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS
export function getOs() {
  return md.os() === 'iOS'
    ? 'ios'
    : (md.os() === 'AndroidOS' ? 'android' : 'windows');
}



// WEBPACK FOOTER //
// ./src/services/mobile.js